import type { TweetResponseBasicInfoAllOf } from './tweetResponseBasicInfoAllOf';
import type { TweetResponseBasicInfoAllOfTwo } from './tweetResponseBasicInfoAllOfTwo';

export type TweetResponseBasicInfo = TweetResponseBasicInfoAllOf & TweetResponseBasicInfoAllOfTwo;
